"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.ensureEnv = exports.ensureString = exports.ensureDefined = exports.invariantDefined = exports.InvariantError = void 0;
class InvariantError extends Error {
}
exports.InvariantError = InvariantError;
function invariantDefined(instance, message) {
    if (instance === undefined || instance === null) {
        throw new InvariantError(message !== null && message !== void 0 ? message : `Expected instance to be defined, received: ${instance}`);
    }
}
exports.invariantDefined = invariantDefined;
function ensureDefined(instance, message) {
    invariantDefined(instance, message);
    return instance;
}
exports.ensureDefined = ensureDefined;
function ensureString(input, message) {
    if (typeof input !== 'string') {
        throw new InvariantError(message !== null && message !== void 0 ? message : `Expected instance to be string, received: ${input}`);
    }
    return input;
}
exports.ensureString = ensureString;
// Like ensureDefined, but with predefined message
function ensureEnv(variableName) {
    const res = process.env[variableName];
    if (res === undefined) {
        throw new InvariantError(`Environment variable '${variableName}' is required`);
    }
    return res;
}
exports.ensureEnv = ensureEnv;
function isDefined(instance) {
    return instance !== null && instance !== undefined;
}
exports.isDefined = isDefined;
//# sourceMappingURL=index.js.map